import request from '@/found/utils/request';
import Form from '@/found/components/form/form.vue';
import cashOrderInfo from '../cashOrderInfo/index';

formCreate.component('cashOrderInfo', cashOrderInfo);
export default {
  extends: Form,
  data() {
    return {
      formFunctionCode: 'add_tack_order',
      buttonText: {
        submit: '提交',
      },
      // 传true则显示该按钮
      buttons: {
        submit: true, // 点击会执行submit(btnType)函数，接收bntType为：1
      },
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  created() {
  },
  methods: {
    async formComplete() {
      console.log(this.formConfig);

      if (this.formConfig.code === 'view' && this.formConfig.row.orderStatus === '3') {
        this.buttons.submit = true;
        this.disabled(false, ['logisticsNumber']);
      } else {
        this.buttons.submit = false;
        this.disabled(true, ['logisticsNumber']);
      }

      await this.loadData();
    },
    async loadData() {
      if (this.formConfig.row && this.formConfig.row.id) {
        const { result } = await request.post(
          '/cps/v1/cashOrder/findCashOrderDetail',
          {
            id: this.formConfig.row.id,
          },
        );
        if (!result) return;
        const cashOrderInfoRule = this.getRule('cashOrderInfo');
        console.log('cashOrderInfo', cashOrderInfoRule);
        cashOrderInfoRule.props.propsObj = result.memberCashOrderProductInfo;
        this.setValue({
          ...result,
          cashOrderInfo: result.memberCashOrderProductInfo,
        });
      }
    },
    /**
     * 设置自定义配置信息
     * @param {object} item 获取配置信息
     * @returns {object} v 返回自定义配置信息
     */
    setRule(item) {
      const v = item;
      return v;
    },
    async submit(e) {
      console.log('submit', e);
      const formData = this.getFormData();
      console.log('formData', formData);
      const params = {
        ...formData,
        id: this.formConfig.row.id,
      };
      if (!formData) return;
      request.post('/cps/v1/cashOrder/subLogistics', params).then((res) => {
        this.$message({
          type: 'success',
          message: '操作成功',
        });
        this.$emit('onClose');
        this.$emit('onGetList');
      });
    },
  },
};
